import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import {
  CardComponent,
  CardContentComponent,
  IconComponent,
} from '@gains-com/ui-angular';
import { PurchaseDialogHeaderComponent } from '../purchase-dialog-header/purchase-dialog-header.component.js';
import { BoostVM } from '../../../../core/view-states/promotions-view.service.js';

@Component({
  selector: 'app-regular-boost-view',
  templateUrl: './regular-boost-view.component.html',
  styleUrls: ['../styles.scss', './regular-boost-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CardComponent,
    CardContentComponent,
    IconComponent,
    CurrencyPipe,
    PurchaseDialogHeaderComponent,
  ],
})
// Native's BoostInfoSheet has an optional "Switch Promo" secondary button
// (boost_info_sheet.dart). All current native call sites default
// showSwitchPromo: false, so it is intentionally not implemented here.
export class RegularBoostViewComponent {
  boost = input.required<BoostVM>();

  readonly back = output<void>();
  readonly close = output<void>();

  readonly percentage = computed(() => Math.round(this.boost().percentage));

  readonly maxAmount = computed(() => {
    const raw = this.boost().max_boost_eligibility_amount_usd;
    if (!raw) return null;
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : null;
  });
}
